export enum QuestionType {
  FreeText = "FREE_TEXT",
  MultipleChoice = "MULTIPLE_CHOICE",
  YesNo = "YES_NO"
}
